import { IAsset } from "@/v1/components/pages/GameDetail/components/AssetsTab/types/Asset.interface";

import { StateType } from "../useRequestsStore";

export const updateQueueAsset = (asset: IAsset, newAsset: IAsset, { set }: StateType) => {
  set(({ queue }) => ({
    queue: queue.map(queueAsset => (queueAsset.id === asset.id ? newAsset : queueAsset)),
  }));
};
